import {Mapper} from '../../../../../core/abstracts/mapper.abstract';
import {VehicleAvailableKeyNumberResponse} from '../../../key-number/model/vehicle-available-key-number.response';
import {VehicleAvailableKeys} from '../model/vehicle-available-keys.model';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class VehicleAvailableKeysResponseMapper extends Mapper<VehicleAvailableKeyNumberResponse, VehicleAvailableKeys> {
  override map(source: VehicleAvailableKeyNumberResponse): VehicleAvailableKeys {
    return new VehicleAvailableKeys(source.keyNumber);
  }
}
